import { HomePageWidgetTypes } from "@irati/types";
var tempWidget = {
    id: "temp",
    type: HomePageWidgetTypes.ImageWithText,
    imageWithText: {
        image: "https://res.cloudinary.com/perkbox/image/upload/v1562871407/deals-light-ui/web/homepage/Untitled-111.jpg",
        header: "home.customisation.tempWidget.header",
        body: "home.customisation.tempWidget.body"
    },
    layouts: {
        desktop: { xOffset: 2, yOffset: 0, width: 2, height: 2 },
        mobile: { xOffset: 2, yOffset: 0, width: 2, height: 2 }
    }
};
export default tempWidget;
